// extracted by mini-css-extract-plugin
export default {"error-banner-container__marginBotton":"error-banner-container__marginBotton_wng7WGRp"};